// @flow
import type { IdentifyUserAgentAction, UserAgentInfo } from '../../actions/client';

export type State = UserAgentInfo;

const initialState = {
  isDesktop: false,
  isMobile: false,
  isTablet: false,
  isiPhone: false,
  isiPad: false,
  isiPod: false,
  isMac: false,
  isWindows: false,
  isAndroid: false,
  isAndroidTablet: false,
  isChrome: false,
  isSafari: false,
  isFirefox: false,
  isSmartTV: false,
  source: '',
};

export default function userAgentInfo(
  state: State = initialState,
  action: IdentifyUserAgentAction
): State {
  if (action.type === 'IDENTIFY_USER_AGENT') {
    return action.userAgentInfo;
  }

  return state;
}
